module.exports = __webpack_public_path__ + "img/disconnected.e43b0192.png";